import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type HotelAccountsController from 'lumen/controllers/hotel/accounts';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';
import getEnv from 'lumen/helpers/get-env';

interface HotelAccountsSignature {
  Args: {
    controller: HotelAccountsController;
    model: unknown;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "menu.spider.accounts"))}}

  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-account-analysis"
    @query={{@controller.iframeQPs}}
    @url={{@controller.urlForEmbeddedApp}}
  />
</template> satisfies TOC<HotelAccountsSignature>;
